import React from 'react'

const useTurnstileScript = () => {
  const [loaded, setLoaded] = React.useState(false)
  const [error, setError] = React.useState(false)
  const script = React.useRef()
  React.useEffect(() => {
    if (!window.turnstile) {
      script.current = document.createElement('script')
      script.current.type = 'text/javascript'
      script.current.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
      script.current.async = true
      document.head.appendChild(script.current)
      script.current.onload = () => {
        setLoaded(true)
      }
      script.current.onerror = () => {
        setError(true)
      }
    } else {
      setLoaded(true)
    }
  }, [])
  return { loaded, error }
}

export default useTurnstileScript
